export class ButtonsState {
  editDraw= false;
  deleteItem= false;
  export= true;
  save= false;
  cancel= false;
  cutTool= false;
  new= true;
}
